import { render } from "./Laptop.vue?vue&type=template&id=69486f68"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Laptop.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "69486f68"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('69486f68', __exports__)) {
    api.reload('69486f68', __exports__)
  }
  
  module.hot.accept("./Laptop.vue?vue&type=template&id=69486f68", () => {
    api.rerender('69486f68', render)
  })

}


export default __exports__